import { useMemo, useState } from 'react';
import type { HeaderImage } from '../types';

export const useKeywordSearch = (headers: HeaderImage[]) => {
  const [keyword, setKeyword] = useState('');

  const matches = useMemo(() => {
    const searchTerm = keyword.trim().toLowerCase();
    const searchTerms = searchTerm.split(/\s+/);

    if (!searchTerm.trim().length) {
      return headers;
    }

    return headers.filter((header) => {
      const lowercaseId = header.id.toLowerCase();
      const keywords =
        header.keywords?.split(',').map((k) => k.toLowerCase()) ?? [];

      return searchTerms.every(
        (term) =>
          lowercaseId.includes(term) ||
          keywords.some((keyword) => keyword.includes(term))
      );
    });
  }, [keyword, headers]);

  const clear = () => {
    setKeyword('');
  };

  return {
    matches,
    keyword,
    setKeyword,
    clear,
  };
};
